<template>
  <div>
    <div>
      <!-------- start toast / snackbar------------------->
      <success-toast-component
        :SuccessToast="SuccessToast"
        :action="categoryAction"
        @close="close"
      />
      <error-toast-component :ErrorToast="ErrorToast" @close="close" />
      <!-------- end toast / snackbar------------------->
      <!------------------section one------------------------>
      <v-row class="d-flex justify-space-between" flat>
        <v-col md="6" sm="6">
          <h1 class="heading-1">Courses</h1>
        </v-col>
        <!--------------------------- add courses --------------------------------------->
        <v-col md="6" sm="6">
          <v-card flat class="d-flex justify-end mt-2">
            <!-- <v-btn color="primary">Add new</v-btn> -->
            <v-btn
              color="#A1A1A6"
              outlined
              class="text_style px-7 mr-4"
              depressed
              @click="(SuccessToast = false), (organizeDialog = true)"
            >
              Manage Categories
            </v-btn>
            <!-- <v-btn
              color="primary"
              dark
              class="text_style px-14"
              depressed
              @click="(SuccessToast = false), (AddCourseDialog = true)"
            >
              Add new
            </v-btn> -->
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="text_style px-14"
                >
                  Add new
                </v-btn>
              </template>
              <v-list>
                <v-card flat>
                  <router-link to="/newcourse" style="color: black">
                    <div class="mx-5 mt-3"><b> Course </b></div>
                  </router-link>
                  <v-divider class="divider"></v-divider>
                  <router-link to="/newparamacourse" style="color: black">
                    <div class="mx-5"><b> PaRama course </b></div>
                  </router-link>
                  <v-divider class="divider"></v-divider>
                  <router-link to="/newparamabundle" style="color: black">
                    <div class="mx-5 mb-3"><b>PaRama Bundle </b></div>
                  </router-link>
                </v-card>
              </v-list>
            </v-menu>
          </v-card>
        </v-col>
      </v-row>
      <!------------------section two------------------------>
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" md="4" sm="6">
            <v-card flat>
              <v-text-field
                dense
                outlined
                class="mt-1"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                v-model="search"
                @input="searchData()"
              >
              </v-text-field>
            </v-card>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <v-btn
              color="#A1A1A6"
              outlined
              style="height: 43px;"
              class="d-flex border mr-1"
              @click="filterDialog = true"
            >
              <div>
                <v-icon class="mr-auto">mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px;"
                  >Filters
                </span>
              </div>
            </v-btn>
            <!-- <v-card
              height="45"
              outlined
              class="px-2 mt-n1 d-flex justify-start align-center"
              style="cursor: pointer"
              @click="filterDialog = true"
            >
              <div
                class="d-flex justify-space-between align-center"
                style="width: 100%"
              >
                <div>
                  <v-icon>mdi-tune</v-icon>
                  <span class="text_style mx-1" style="letter-spacing: 1px"
                    >Filters</span
                  >
                </div>

                <div>
                  <v-icon>mdi-menu-down</v-icon>
                </div>
              </div>
            </v-card> -->
            <!------------------------fliter diloag------------------------------------------>
            <v-dialog v-model="filterDialog" max-width="430" persistent>
              <v-card class="py-5">
                <v-card-title
                  class="mb-5 d-flex justify-space-between align-center"
                >
                  <div class="text-h5"><b> Filters</b></div>
                  <div>
                    <v-btn text depressed class="pa-0" @click="cleanFilter()">
                      <span
                        class="text_style primary--text"
                        style="letter-spacing: 0px"
                        >Clean filters</span
                      >
                    </v-btn>
                    <v-icon class="ml-3" @click="handleCloseFilter()"
                      >mdi-close</v-icon
                    >
                  </div>
                </v-card-title>

                <v-card-text>
                  <v-select
                    outlined
                    v-model="filterCategory"
                    :items="GetCourseCategories"
                    dense
                    hide-details
                    label="Category"
                    multiple
                    item-value="Id"
                    item-text="CategoryName"
                    persistent-hint
                    :menu-props="{ maxHeight: '400' }"
                  ></v-select>
                  <v-select
                    outlined
                    class="my-5"
                    v-model="filterStatus"
                    :items="filterStatusArray"
                    dense
                    :menu-props="{ maxHeight: '400' }"
                    hide-details
                    label="Status"
                    multiple
                    persistent-hint
                  ></v-select>
                  <v-select
                    outlined
                    class="my-5"
                    v-model="filterCourses"
                    :items="filterCoursesArray"
                    item-text="name"
                    item-value="id"
                    dense
                    :menu-props="{ maxHeight: '400' }"
                    hide-details
                    label="Courses"
                    multiple
                    persistent-hint
                  ></v-select>
                  <v-select
                    outlined
                    v-model="filterType"
                    :items="filterTypeArray"
                    item-value="Id"
                    item-text="item"
                    dense
                    :menu-props="{ maxHeight: '400' }"
                    hide-details
                    label="Type"
                    multiple
                    persistent-hint
                  ></v-select>

                  <!---------------------Type-modalitiy model filter-------------------------------->
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#646464"
                    outlined
                    depressed
                    class="px-5"
                    text
                    @click="handleCloseFilter()"
                  >
                    <span class="text_style"> Cancel </span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="px-8 ml-2"
                    @click="sendFilters()"
                    depressed
                  >
                    <span class="text_style"> Save Filters </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <div class="d-flex justify-end">
              <v-btn color="primary" to="/royaltycourses"
                >PaRama Campus Royalty Report
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <!-------------------data table ------------->

      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          disable-pagination
          :search="search"
          :items="DataTableOne"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ index }">
            <b class="index_index_text">
              {{ index + displayedItemsPerPage * (page - 1) + 1 }}
            </b>
          </template>
          <template v-slot:[`item.title`]="{ item }">
            <span class="index_head_text"> {{ item.Title }} </span>
          </template>
          <template v-slot:[`item.CategoryNames`]="{ item }">
            <span class="index_head_text"> {{ item.CategoryNames }} </span>
          </template>
          <template v-slot:[`item.update`]="{ item }">
            <span class="index_head_text"> {{ item.update }} </span>
          </template>
          <template v-slot:[`item.CourseType`]="{ item }">
            <span class="index_head_text">
              <v-chip id="chip" small :class="`${item.CourseType}`">
                {{ item.CourseType == 1 ? "Course" : "" }}</v-chip
              >
            </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon @click="toggleIsPlaying(item.Id)" class="mx-5">
              <v-icon v-if="item.Visibility" color="primary">mdi-eye</v-icon>
              <v-icon v-else>mdi-eye-off</v-icon>
            </v-btn>
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="item.CourseType == '1'"
                >
                  <v-btn
                    @click="openCourse(item.Id)"
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Open Course</span
                    >
                  </v-btn>
                </v-list>
                <router-link to="/seeparamacourses">
                  <v-list
                    class="px-3 pt-1"
                    color="transparent"
                    v-if="item.type == 'PaRama'"
                  >
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                    >
                      <v-icon color="#646464">mdi-open-in-new</v-icon>
                      <span class="ml-4 text_style action_dialog"
                        >Open PaRama Course</span
                      >
                    </v-btn>
                  </v-list>
                </router-link>

                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="item.CourseType == '1'"
                >
                  <v-btn
                    @click="editCourse(item.Id)"
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Edit Course</span
                    >
                  </v-btn>
                </v-list>
                <router-link to="/editparamacourse">
                  <v-list
                    class="px-3 pt-1"
                    color="transparent"
                    v-if="item.type == 'PaRama'"
                  >
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                    >
                      <v-icon color="#646464">mdi-pencil</v-icon>
                      <span class="ml-4 text_style action_dialog"
                        >Edit parama Course</span
                      >
                    </v-btn>
                  </v-list>
                </router-link>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="item.CourseType == '1'"
                >
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    :to="`/Seminars?courseId=${item.Id}`"
                    @click="console(item)"
                  >
                    <v-icon color="#646464">mdi-plus-circle</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Add new Seminar</span
                    >
                  </v-btn>
                </v-list>

                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="item.type == 'PaRama Bundle'"
                >
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    to="/editparamabundle"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Edit PaRama Bundle</span
                    >
                  </v-btn>
                </v-list>

                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="item.CourseType == '1'"
                >
                  <v-btn
                    @click="duplicateIddata(item.Id)"
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-file-multiple</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Duplicate Course</span
                    >
                  </v-btn>
                </v-list>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  v-if="Permission.Delete"
                >
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="selectedIddata(item.Id)"
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style action_dialog"
                      >Delete Course
                    </span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @change="handleItemPerPage()"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @input="fetchData"
        ></v-pagination
      ></v-card>
    </div>

    <!-------------Delete Dialog---------------------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="btnloader" @click="DeleteData()">
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-----------------Organize dialog--------------------------------------->
    <v-dialog v-model="organizeDialog" persistent max-width="660">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-space-between">
          <div class="d-flex align-center">
            <span class="h5 mb-1">Organize</span>
            <!-- <v-dialog v-model="newcategorydialog" persistent max-width="450">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  text
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="text_style"
                  @click="SuccessToast = false"
                >
                  + Create Category
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="py-5 d-flex justify-space-between">
                  <h5 class="text_style">Add Category</h5>
                  <v-icon @click="handleCancelNewCategory()">mdi-close</v-icon>
                </v-card-title>
                <v-card color="#F6F8FC" flat class="py-2 px-6">
                  <v-text-field
                    label="Name Category"
                    required
                    v-model="$v.Name.$model"
                    hide-details
                  ></v-text-field>
                  <div class="red--text mt-2" v-if="$v.Name.$error">
                    Name is required
                  </div>
                </v-card>
                <v-card-actions class="pb-8 pt-8">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="px-14 py-5"
                    text
                    @click="handleCancelNewCategory()"
                  >
                    Cancel
                  </v-btn>
                  <v-btn color="primary" @click="save()" class="px-14">
                    <v-progress-circular
                      indeterminate
                      size="20"
                      class="px-5"
                      color="white"
                      v-if="btnloader"
                    ></v-progress-circular>
                    <span v-else class="text_style">Save</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
          </div>
          <v-icon @click="organizeDialog = false">mdi-close</v-icon>
        </div>
        <OrganizeComponent
          :organizeDialog="organizeDialog"
          @close="close"
          @fetchData="handlefetchData"
        ></OrganizeComponent>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import OrganizeComponent from "../../components/Courses/organize.component.vue";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    SuccessToastComponent,
    ErrorToastComponent,
    OrganizeComponent,
  },
  data() {
    return {
      AddCourseDialog: false,
      btnloader: false,
      newcategorydialog: false,
      organizeDialog: false,
      categoryAction: "",
      filtersArray: [],
      filterCourse: [],
      filterCourseArray: ["All courses", "My courses"],
      filterType: [],
      filterTypeArray: [
        {
          Id: 1,
          item: "Course",
        },
        {
          Id: 2,
          item: "Parama Course",
        },
        {
          Id: 3,
          item: "Parama Course Bundle",
        },
      ],
      filterStatus: [],
      filterCourses: [],
      filterStatusArray: ["Draft", "Published"],
      filterCoursesArray: [
        { name: "Active", id: true },
        { name: "Inactive", id: false },
      ],
      filterCategory: [],
      filterCategoryArray: [
        "Anatomy and Physiology",
        "AnimalTalk",
        "BodyTalk Access",
        "BodyTalk Courses",
        "BreakThrough",
        "CEUs",
        "Conferences",
        "Courses LS",
        "FREE Courses",
        "FSI",
        "Group Sessions",
      ],
      filterDialog: false,
      snackbar: false,
      SuccessToast: false,
      ErrorToast: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      tableLoader: false, // data-table true or false
      dialog: false,
      isPlaying: false,
      search: "",
      Name: "",
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Title", value: "Title" },
        { text: "Display Order", value: "DisplayOrder" },
        { text: "Category", value: "CategoryNames" },
        { text: "CEUs", value: "CEUs" },
        { text: "Type", value: "CourseType" },
        { text: "Status", value: "Status" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
      SelectedID: "",
    };
  },
  validations: {
    Name: {
      required,
    },
  },
  computed: {
    ...mapGetters([
      "GetUserRolePermissions",
      "GetLoggedInUser",
      "GetCourses",
      "GetCourseCategories",
      "GetPreviewCourse",
    ]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.DataTableOne.length
        : this.itemsPerPage;
    },
  },
  mounted() {
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Coordinator"
    );
    this.filterCategory = this.$store.state.filterCategory;
    this.filterStatus = this.$store.state.filterStatus;
    this.filterCourses = this.$store.state.filterCourses;
    this.filterType = this.$store.state.filterType;
    if (this.filterType || this.filterCategory || this.filterStatus || this.filterCourses) {
      this.sendFilters();
    }else{
      this.fetchData();
    }
    this.tableLoader = true;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!from.path.startsWith("/editCourse") && !from.path.startsWith("/seecourse")) {
        vm.$store.state.filterCategory = [];
        vm.$store.state.filterStatus = [];
        vm.$store.state.filterCourses = [];
        vm.$store.state.filterType = [];
      }
    });
  },
  methods: {
    handleCancelNewCategory() {
      this.newcategorydialog = false;
      this.resetNewCategory();
    },
    handlefetchData(signal) {
      this.categoryAction = signal;
      // this.SuccessToast = true;
      this.$swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Edited successfully",
        showConfirmButton: false,
        timer: 1500,
      });
      this.fetchData();
    },
    handleCloseFilter() {
      this.cleanFilter();
      this.filterDialog = false;
    },
    console(item) {
      console.log(item);
    },
    async toggleIsPlaying(id) {
      await this.$store.dispatch("ToggleCourseVisiblity", id);
      this.fetchData();
    },
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchData();
    },
    selectedIddata(id) {
      this.SelectedID = id;
      this.dialog = true;
    },
    async duplicateIddata(id) {
      await this.$store.dispatch("DuplicateCourseById", id);
      this.fetchData();
      this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Duplicated Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
    },
   editCourse(id) {
      this.$router.push(`/editCourse/${id}`);
    },
   openCourse(id) {
      this.$router.push(`/seecourse/${id}`);
    },
    DeleteData() {
      this.btnloader = true;
      this.$store
        .dispatch("DeleteCourse", this.SelectedID)
        .then(() => {
          // The DeleteCourse action has completed successfully
          this.dialog = false;
          this.btnloader = false;
          this.categoryAction = "delete";
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Deleted successfully",
            showConfirmButton: false,
            timer: 1500,
          });

          // here for a short time before fetching data
          setTimeout(() => {
            this.fetchData();
            this.SuccessToast = false;
          }, 2000);
        })
        .catch((error) => {
          // Handle error if DeleteCourse action fails
          console.error("DeleteCourse Action Error:", error);
        });
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var obj = {
          CategoryName: this.Name,
          UserId: this.GetLoggedInUser.Id,
        };
        this.btnloader = true;
        this.$store
          .dispatch("CreateCourseCategory", obj)
          .then(() => {
            this.btnloader = false;
            this.newcategorydialog = false;
            this.categoryAction = "add";
            this.SuccessToast = true;
            this.fetchData();
            this.resetNewCategory();
          })
          .catch((error) => {
            console.error("API Request Error:", error);
            this.btnloader = false;
          });
      }
    },
    resetNewCategory() {
      this.$v.Name.$model = "";
      this.$v.$reset();
    },
    searchData(){
      this.page = 1;
      this.fetchData()
    },
    async fetchData() {
      const obj = {
        page: this.page,
        pageSize: this.itemsPerPage === "All" ? "all" : this.itemsPerPage,
        search: this.search,
        filters: JSON.stringify(this.filtersArray),
      };
      this.GetCourseCategories.length == 0 && await this.$store.dispatch("GetCourseCategories");
      this.tableLoader = true;
      await this.$store
        .dispatch("GetCourse", obj)
        .then((res) => {
          this.tableLoader = false;
          this.DataTableOne = this.GetCourses;
          if (this.itemsPerPage != "All") {
            this.pageCount = Math.ceil(res.totalRecords / this.itemsPerPage);
          } else {
            this.pageCount = 1;
          }

          // if (this.pageCount > 1) {
          //   this.page = res.page;
          // } else {
          //   this.page = 1;
          // }
        })
        .catch((error) => {
          console.error("API Request Error:", error);
          this.tableLoader = false;
        });
    },
    close() {
      this.organizeDialog = false;
      this.fetchData();
    },
    cleanFilter() {
      this.filterCategory = [];
      this.filterStatus = [];
      this.filterType = [];
      this.filterCourseArray = [];
      this.filterCourses = [];
    },
    sendFilters() {
      this.page = 1;
      this.filtersArray = [];
      this.$store.state.filterCategory = this.filterCategory;
      this.$store.state.filterStatus = this.filterStatus;
      this.$store.state.filterCourses = this.filterCourses;
      this.$store.state.filterType = this.filterType;
      if (this.filterCategory.length > 0) {
        this.filtersArray.push({
          Key: "Categories",
          Value: this.filterCategory.join(","),
        });
      }
      if (this.filterStatus.length > 0) {
        this.filtersArray.push({
          Key: "Statuses",
          Value: this.filterStatus.join(","),
        });
      }
      if (this.filterCourses.length > 0) {
        this.filtersArray.push({
          Key: "Visibility",
          Value: this.filterCourses.join(","),
        });
      }
      if (this.filterType.length > 0) {
        this.filtersArray.push({
          Key: "CourseTypes",
          Value: this.filterType.join(","),
        });
      }
      this.fetchData();
      this.filterDialog = false;
    },
    // toggleIsPlaying(obj) {
    //   this.DataTableOne = this.DataTableOne.map((e) => {
    //     if (e.index === obj) {
    //       e.isPlaying = !e.isPlaying;
    //       return e;
    //     }
    //     return e;
    //   });
    //   this.isPlaying = !this.isPlaying;
    // },
  },
};
</script>

<style scoped>
#chip.v-chip.Course {
  background: #e8f3fa;
  padding: 0 16%;
  color: #0071bd;
}

#chip.v-chip.PaRama {
  background: #fdf7e7;
  padding: 0 16%;
  color: #d18911;
}

#chip.v-chip.PaRama.Bundle {
  background: #dff2d5;
  padding: 0 16%;
  color: green;
}

.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
